
//import {httpsCallable} from "firebase/functions"
//import {ref,uploadBytes,getDownloadURL} from "firebase/storage"
import {NoticeProps} from "@/scripts/datatypes"
import { Component,Watch ,Mixins} from "vue-property-decorator"
import Common from '@/mixins/common'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ModalSelectUser from '@/components/ModalSelectUser.vue'
import { UserPublicProfile, UserRelationship } from "@/common-datatypes"
import { DocumentReference, getDoc } from "firebase/firestore"
import { ValidationFlags } from "vee-validate/dist/types/types"
import TemplateMembers from '@/components/TemplateMembers.vue'

@Component({
  components: {
    ModalSelectUser,
    TemplateMembers
  }
})

export default class EditUserRelationship extends Mixins(Common) {
  isLoading = false
  initialized = false

  notice: NoticeProps = {}
  disablededitUserRelationship = true
  userPublicProfile = {} as UserPublicProfile
  userRelationship: UserRelationship = {
    children: [],
    parents: []
  }

  showSelectChildPanel = false

  showSelectParentPanel = false

  observer = {} as InstanceType<typeof ValidationObserver>

  $refs!: {
    parents: InstanceType<typeof ValidationProvider>;
    children: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get displayName(){
    return this.$t('text.name', {lastName: this.userPublicProfile.lastName || '', firstName: this.userPublicProfile.firstName || ''})
  }

  get existUser(){
    if(this.userPublicProfile.creationTime && this.userRelationship.creationTime){
      return true
    }else{
      return false
    }
  }

  @Watch('initialized',{immediate: true})
  changeInitializedStatus(newVal: boolean){
    if(! newVal){
      this.notice = {
        message: this.$t('editUser.loadingUserData') as string,
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }
    }else if(! this.existUser){
      this.notice = {
        message: this.$t('editUser.noUserFound') as string,
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }else{
      this.notice = {
        isShow: false,
      }
    }
  }

  get theUserId(){
    return this.$route.params.userId || ''
  }

  mounted(){
    console.log('mounted')
  }

  updated(){
    console.log('mounted')
    if(! this.observer.flags && this.$refs.validationObserver){
      this.observer = this.$refs.validationObserver
      this.$watch('observer.flags', (flags: ValidationFlags) => {
        this.disablededitUserRelationship = ! flags.changed
      })
    }
  }

  initUserFamily: string[] = []

  get hasRoleParent(){
    return !! (this.userPublicProfile.roles && this.userPublicProfile.roles.includes('parent'))
  }

  get hasRoleStudent(){
    return !! (this.userPublicProfile.roles && this.userPublicProfile.roles.includes('student'))
  }

  get hasRoleTrainee(){
    return !! (this.userPublicProfile.roles && this.userPublicProfile.roles.includes('trainee'))
  }

  get hasRoleChild(){
    return this.hasRoleStudent || this.hasRoleTrainee
  }

  async created() {
    console.trace('created')
    try{
      this.$store.commit('setLoading',true)
      this.isLoading = true

      const [userPublicProfileDoc,userRelationshipDoc] = await Promise.all([
        getDoc(this.$getUserPublicProfileDocRef(this.theUserId)),
        getDoc(this.$getUserRelationshipDocRef(this.theUserId)),
      ])

      this.userPublicProfile = ((userPublicProfileDoc.exists() && userPublicProfileDoc.get('deleted') !== true) ? userPublicProfileDoc.data() : {}) as UserPublicProfile

      const userRelationship = (userRelationshipDoc.exists() ? userRelationshipDoc.data() : {}) as UserRelationship

      this.userRelationship = {
        ...userRelationship
      }
      this.initUserFamily = userRelationship.family || []

    }catch(error){
      //console.log(error)
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoading = false
      this.initialized = true
    }
  }

  get userFamily(){
    return Array.from(new Set([...this.userRelationship.parents,...this.userRelationship.children,...this.initUserFamily]))
  }

  async editUserRelationship(){
    try{
      this.notice = {
				isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }

      const updateRelationship = {
        ...this.userRelationship
      }

      if(updateRelationship.family){
        delete updateRelationship.family
      }

      if(updateRelationship.familyMeta){
        delete updateRelationship.familyMeta
      }
      

      this.$store.commit("setLoading",true);
      this.isLoading = true

      const docRefs: DocumentReference[] = []
      const datas: UserRelationship[] = []

      docRefs.push(this.$getUserRelationshipDocRef(this.theUserId))
      datas.push({...updateRelationship})

      const userRelationshipDocs =  await Promise.all(this.userFamily.map((userId) => {
        return getDoc(this.$getUserRelationshipDocRef(userId))}
      ))

      this.userFamily.forEach((userId,index) =>{
        const relationship = userRelationshipDocs[index].data() as UserRelationship
        if(relationship){
          let update = false
          const parents = relationship.parents
          const children = relationship.children

          const foundInParents = parents.indexOf(this.theUserId)
          const foundInChildren = children.indexOf(this.theUserId)

          if(foundInParents > -1){// found
            if(updateRelationship.children.includes(userId)){ // no change
              //
            }else{ //delete
              parents.splice(foundInParents,1)
              update = true
            }
          }else{// notFound
            if(updateRelationship.children.includes(userId)){ // add
              parents.push(this.theUserId)
              update = true
            }else{ // no cange
              //
            }
          }

          if(foundInChildren > -1){// found
            if(updateRelationship.parents.includes(userId)){ // no change
              //
            }else{ //delete
              children.splice(foundInChildren,1)
              update = true
            }
          }else{// notFound
            if(updateRelationship.parents.includes(userId)){ // add
              children.push(this.theUserId)
              update = true
            }else{ // no cange
              //
            }
          }

          if(update){
            docRefs.push(userRelationshipDocs[index].ref)
            datas.push({
              userId: relationship.userId,
              parents: parents,
              children: children
            })
          }
        }
      })

      console.log(docRefs)

      const userRelationshipRes = await this.$updateDocs(docRefs,datas)

      this.notice = {
        message: this.$t('editUserRelationship.edited') as string,
        isShow: true,
        type: {'is-success': true}
      }
      this.userRelationship = userRelationshipRes?.data() as UserRelationship
      this.$refs.validationObserver.reset()
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('editUserRelationship.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disablededitUserRelationship = true
      //this.observer.reset()
    }
  }
}
